import React, { LazyExoticComponent } from 'react'

import { ConsultationLitePageInterface } from '~/core/config/modules/generated/types'

export * from './utils'

export const LazyConsultationLitePage: LazyExoticComponent<ConsultationLitePageInterface> = React.lazy(
  () => import('./Consultation')
)
